
/* injects from baggage-loader */

'use strict';

export default class ProjectInvestmentWizardStep2Controller {

	constructor($log, InvestmentWizard, UsStates, Countries) {
		'ngInject';

		this.$log = $log;
		this.InvestmentWizard = InvestmentWizard;

		this.countries = Countries;
		this.usStates = UsStates;

		this.certifications = [{
			id: 'correctTaxId',
			text: 'The number shown on this form is my correct taxpayer identification number.'
		}, {
			id: 'usCitizen',
			text: 'I am a U.S. citizen or other U.S. person.'
		}];

		// Setup certifications
		if (typeof this.InvestmentWizard.investment.certifications === 'undefined') {
			this.InvestmentWizard.investment.certifications = this.certifications;
		}

	}

	$onInit() {
		
	}


	/**
	 * Called when a certifications box is checked
	 * @param {Object} certifications
	 */
	certificationChecked(certification) {

		// Record timestamp of certification check
		certification.ts = certification.checked ? new Date() : undefined;

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step2/projectinvestmentwizard.step2.controller.js